import React from 'react';
import HomeOptions1 from '../HomeOptions1';
import CarouselHome from './CarouselHome';

const Home = () => {
    return (
        <div>
            <CarouselHome></CarouselHome>
            <HomeOptions1></HomeOptions1>

        </div>
    );
};

export default Home;